import axios from 'axios'

import {
  ScenarioCompareDTO,
  ScenariosComparisonGroupedAnnuallyDTO
} from '@/interfaces'

const baseUrl = `/api/ScenarioComparison`
export const scenarioComparisonClient = {
  QUERY_KEY: ['projects', 'scenarios', 'comparison'],
  getScenarioComparison: (scenarioIds: number[]) =>
    axios
      .get<ScenarioCompareDTO[]>(baseUrl, {
        params: { scenarioIds },
        paramsSerializer: () =>
          scenarioIds.map(x => `scenariosIds=${x}`).join('&')
      })
      .then(x => x.data),
  getScenarioAnnualComparison: (scenarioIds: number[]) =>
    axios
      .get<ScenariosComparisonGroupedAnnuallyDTO[]>(`${baseUrl}/Annually`, {
        params: { scenarioIds },
        paramsSerializer: () =>
          scenarioIds.map(x => `scenariosIds=${x}`).join('&')
      })
      .then(x => x.data),
  downloadScenarioComparisonReport: (scenarioIds: number[]) =>
    axios
      .get<Blob>(`${baseUrl}/Export`, {
        responseType: 'blob',
        params: { scenarioIds },
        paramsSerializer: () =>
          scenarioIds.map(x => `scenariosIds=${x}`).join('&')
      })
      .then(x => x.data)
}
